export class Character {
  constructor(title) {
    this.title = title;
    // this.iconSrc = iconSrc;
    // this.imgSrc = imgSrc;
  }
}